import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { redirectToPageCredentials, setSidemenuFlag } from '../ReduxState';
import { toast } from 'react-toastify';

function SideMenu({ openSideMenu, handleSideMenu }) {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const classValue = openSideMenu ? "side-menu open" : "side-menu";
    const sidemenuFlag = useSelector(state => state.sidemenu.sideMenuFlag);
    const [disableMenu, setDisableMenu] = useState(false);
    
    const notify = (e, autoClose) => 
    toast.error(e, {
        position: "top-right",
        autoClose: autoClose,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });


    var page = document.getElementsByTagName('body')[0];

    if (openSideMenu) {
        page.classList.add('noBodyScroll');
    } else {
        page.classList.remove('noBodyScroll');
    }

    // if (['/Search', '/'].includes(location.pathname)) {
    //     setDisableMenu(true);
    //     // notify('Please proceed with a PNR first', 3000);
    // }

    const goTo = (page) => (event) => {
        if (!['/PassengerInformation', '/Comments', '/PnrHistory', 'ManifestDetail', 'PeripheralDevices'].includes(location.pathname)) {
            dispatch(redirectToPageCredentials(
                {
                    type: "",
                    redirectionPage: location.pathname
                }
            ));
        }
        
        handleSideMenu();
        // dispatch(setSidemenuFlag(
        //     {
        //         type: "",
        //         sideMenuFlag: !sidemenuFlag
        //     }
        // ));
        history.push(`/${page}`);
    }

    useEffect(() => {
        // debugger
        console.log('29936', location.pathname)
        if (['/Search', '/', '/ManifestDetail', '/PeripheralDevices'].includes(location.pathname)) {
            //   handleSideMenu();
            setDisableMenu(true);
        } else {
            setDisableMenu(false);
        }
    },[location])

    return (
        <div class={classValue}>
            <ul class="menu-list">
                <li class="menu-item">
                    {
                        disableMenu ?
                        <div class="menu-disabled">
                            <span class="menu-icon"><img src="images/passenger-info.svg" /> </span>
                            <span class="menu-text">Passenger Information(CTRL+i)</span>
                        </div> : 
                        <a onClick={goTo('PassengerInformation')} class="menu-link">
                            <span class="menu-icon"><img src="images/passenger-info.svg" /> </span>
                            <span class="menu-text">Passenger Information(CTRL+i)</span>
                        </a>
                    }
                </li>
                <li class="menu-item">
                    {   
                        disableMenu ?
                        <div class="menu-disabled">
                            <span class="menu-icon"><img src="images/history.svg" /> </span>
                            <span class="menu-text">PNR History(CTRL+h)</span>
                        </div> : 
                        <a onClick={goTo('PnrHistory')} class="menu-link">
                            <span class="menu-icon"><img src="images/history.svg" /> </span>
                            <span class="menu-text">PNR History(CTRL+h)</span>
                        </a>
                    }
                </li>
                <li class="menu-item">
                    {   
                        disableMenu ?
                        <div class="menu-disabled">
                            <span class="menu-icon"><img src="images/comments.svg" /> </span>
                            <span class="menu-text">Comments(CTRL+m)</span>
                        </div> : 
                        <a onClick={goTo('Comments')} class="menu-link">
                            <span class="menu-icon"><img src="images/comments.svg" /> </span>
                            <span class="menu-text">Comments(CTRL+m)</span>
                        </a>
                    }
                </li>
                <li class="menu-item">
                    <a onClick={goTo('ManifestDetail')} class="menu-link">
                        <span class="menu-icon"><img src="images/ManifestWhiteP.png" /> </span>
                        <span class="menu-text">Manifest (CTRL+d)</span>
                    </a>
                </li>
                <li class="menu-item">
                    {   
                        disableMenu ?
                        <div class="menu-disabled">
                            <span class="menu-icon"><img src="images/PeripheralDevicesWhiteP.png" /> </span>
                            <span class="menu-text">Peripheral Devices(CTRL+p)</span>
                        </div> : 
                        <a onClick={goTo('PeripheralDevices')} class="menu-link">
                            <span class="menu-icon"><img src="images/PeripheralDevicesWhiteP.png" /> </span>
                            <span class="menu-text">Peripheral Devices(CTRL+p)</span>
                        </a>
                    }
                </li>
            </ul>
        </div>
    )
}

export default SideMenu;